import {Component} from "@angular/core";
import {GeneralService} from "../../../../services/generalService";
import {NotificationService} from "../../../../services/notificationService";

@Component({
	selector: "url-defanger-tool-component",
	templateUrl: "./url-defanger-tool.component.html",
})
export class UrlDefangerToolComponent {
	constructor(public gs:GeneralService,
				private ns:NotificationService) {}

	undefangUrlTxt;
	defangUrlTxt;

	defangUrlInProcess;
	undefangUrlInProcess;
	defangUrlResult;
	undefangUrlResult;

	defangUrl = () => {
		if (!this.defangUrlTxt) {
			return;
		}

		this.defangUrlTxt = this.defangUrlTxt.trim();
		if (!this.gs.isValidUrl(this.defangUrlTxt)) {
			this.ns.showWarnMessage('Please provide a valid link.')
			return;
		}

		this.defangUrlInProcess = true;

		setTimeout(() => {
			this.defangUrlResult = defangUrlExecute(this.defangUrlTxt);
			this.defangUrlInProcess = false;
		},250);

	};

	undefangUrl = () => {
		if (!this.undefangUrlTxt) {
			return;
		}

		this.undefangUrlTxt = this.undefangUrlTxt.trim();

		this.undefangUrlInProcess = true;

		setTimeout(() => {
			this.undefangUrlResult = this.undefangUrlTxt
				.replace(/\[[:]\]/g, ":")
				.replace(/\[\.\]/g, ".")
				.replace(/hxxp\[:\/\/\]/g, "http://")
				.replace(/hxxps\[:\/\/\]/g, "https://")
				.replace(/fxp\[:\/\/\]/g, "ftp://");
			this.undefangUrlInProcess = false;
		},250);
	};
}

const reDot = /\./g;
const reColon = /\:/g;

function defangUrlExecute(input: string): string {
	let result = "";

	if (isIpAddress(input)) {
		const defangedIP = defangIp(input);
		return defangedIP;
	}

	if (input.substring(0, 7) === "http://") {
		result = helperHttp(input);
	}

	if (input.substring(0, 8) === "https://") {
		result = helperHttps(input);
	}

	if (input.substring(0, 6) === "ftp://") {
		result = helperFtp(input);
	}

	if (result === "") {
		result = helperNoProtocol(input);
	}

	return result;
}

function helperHttp(input: string): string {
	let result = "hxxp[://]";
	const endDomain = input.indexOf("/", 7);
	if (endDomain !== -1) {
		result += input.substring(7, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
		result += input.substring(endDomain);
	} else {
		result += input.substring(7).replace(reDot, "[.]").replace(reColon, "[:]");
	}
	return result;
}

function helperHttps(input: string): string {
	let result = "hxxps[://]";
	const endDomain = input.indexOf("/", 8);
	if (endDomain !== -1) {
		result += input.substring(8, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
		result += input.substring(endDomain);
	} else {
		result += input.substring(8).replace(reDot, "[.]").replace(reColon, "[:]");
	}
	return result;
}

function helperFtp(input: string): string {
	let result = "fxp[://]";
	const endDomain = input.indexOf("/", 6);
	if (endDomain !== -1) {
		result += input.substring(6, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
		result += input.substring(endDomain);
	} else {
		result += input.substring(6).replace(reDot, "[.]").replace(reColon, "[:]");
	}
	return result;
}

function helperNoProtocol(input: string): string {
	let result = "";

	if (input.substring(0, 3) === "://") {
		result += "[://]";
		const endDomain = input.indexOf("/", 3);
		if (endDomain !== -1) {
			result += input.substring(3, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
			result += input.substring(endDomain);
		} else {
			result += input.substring(3).replace(reDot, "[.]").replace(reColon, "[:]");
		}
	} else if (input.substring(0, 2) === "//") {
		result += "[//]";
		const endDomain = input.indexOf("/", 2);
		if (endDomain !== -1) {
			result += input.substring(2, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
			result += input.substring(endDomain);
		} else {
			result += input.substring(2).replace(reDot, "[.]").replace(reColon, "[:]");
		}
	} else {
		const endDomain = input.indexOf("/", 0);
		if (endDomain !== -1) {
			result += input.substring(0, endDomain).replace(reDot, "[.]").replace(reColon, "[:]");
			result += input.substring(endDomain);
		} else {
			result += input.replace(reDot, "[.]").replace(reColon, "[:]");
		}
	}

	return result;
}

function defangIp(input: string): string {
	const doubleColonIndex = input.indexOf("::", 0);
	if (doubleColonIndex !== -1) {
		let result = "";
		result += input.substring(0, doubleColonIndex).replace(reColon, "[:]");
		result += "[::]";
		result += input.substring(doubleColonIndex + 2).replace(reColon, "[:]");
		return result;
	} else {
		return input.replace(reDot, "[.]").replace(reColon, "[:]");
	}
}

function isIpAddress(input: string): boolean {
	const ipv4Pattern = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
	const ipv6Pattern =
		/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;

	return ipv4Pattern.test(input) || ipv6Pattern.test(input);
}
